import { TextEditor } from "pymble-ui";
import "pymble-ui/styles.css";
import "pymble-ui/components.css";

import "./HtmlEditor.css";

interface HtmlEditorProps {
  onChange: (value: string) => void;
}

const HtmlEditor: React.FC<HtmlEditorProps> = ({ onChange }) => {
  return (
    <div className="htmleditor-wrapper">
      <TextEditor
        content=""
        onChange={onChange}
        placeholder="Enter the main body of your email"
      />
    </div>
  );
};

export default HtmlEditor;
